// extracted by mini-css-extract-plugin
export default {"title":"Preview_title__5TP7a"};